import { createSlice } from "@reduxjs/toolkit";

const initialState = {
     isOpen: false,
};

const navSlice = createSlice({
     name: "nav",
     initialState,
     reducers: {
          updateNavListOpen(state) {
               state.isOpen = !state.isOpen;
          },
     },
});

export const navAction = navSlice.actions;
export default navSlice.reducer;
